import React from "react";
import {Field} from "react-final-form";
import Input from "../../../common/components/elements/input/Input";
import RowLayout from "../../../common/components/elements/container/row";
import ColumnLayout from "../../../common/components/elements/container/column";
import {composeValidators, required, beforeDate} from "../../../common/validations";
import Error from "src/core/common/components/elements/Error";
import DatePicker from "../../../common/components/elements/date-picker/DatePicker";
import {Section} from "../../../common/components/elements/container/section";
import {TitleLabel} from "../../../checkout/components/components";
import {showErrorHighlight} from "src/core/common/utils";

function MedicalInfoForm({style, hasErrors, className, title}) {
  const now = new Date();
  const beforeDateValidation = beforeDate(now, "Medical ID already expired.");

  function validateIfNumberRequired(value, allValues) {
    if (allValues.medicalIdExpirationDate || hasErrors) {
      return required(value);
    }
    return undefined;
  }

  function validateIfExpirationDateRequiredRequired(value, allValues) {
    if (allValues.medicalIdNumber || hasErrors) {
      return composeValidators(required, beforeDateValidation)(value);
    } else {
      return beforeDateValidation(value);
    }
  }

  function _hasErrors(meta, input) {
    const metaErrors = showErrorHighlight(meta);
    if (input.value) {
      return metaErrors;
    }

    return metaErrors || hasErrors;
  }

  return (
    <Section className={className} style={style}>
      {title && <TitleLabel>{title}</TitleLabel>}
      <ColumnLayout>
        <RowLayout>
          <Field
            name="medicalIdNumber"
            validate={validateIfNumberRequired}
            render={({input, meta}) => (
              <>
                <Input
                  {...input}
                  hasErrors={_hasErrors(meta, input)}
                  placeholder={"Number"}
                />
                {meta.touched && <Error>{meta.error}</Error>}
              </>
            )}
          />
        </RowLayout>
      </ColumnLayout>
      <ColumnLayout>
        <RowLayout>
          <DatePicker
            name={"medicalIdExpirationDate"}
            placeholder={"Expiration Date"}
            hasErrors={hasErrors}
            validate={validateIfExpirationDateRequiredRequired}
          />
        </RowLayout>
      </ColumnLayout>
      {/*<ColumnLayout style={{marginBottom: "8px"}}>*/}
      {/*<RowLayout>*/}
      {/*<StateSelect name={"medicalIdState"} required />*/}
      {/*</RowLayout>*/}
      {/*</ColumnLayout>*/}
    </Section>
  );
}

export default MedicalInfoForm;
